import Vue from "vue";
import Vuex from "vuex";
import PersistedState from "vuex-persistedstate";

import auth from "./modules/auth";
import rule from "./modules/rule";
import service from "./modules/service";
import budget from "./modules/budget";
import email from "./modules/editTemplateEmail";
import form from "./modules/editTemplateForm";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    auth,
    rule,
    service,
    budget,
    email,
    form
  },
  plugins: [
    PersistedState({
      key: "audiotext-cms"
    })
  ]
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js